var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.25V6.25M7 16.25V20.25M17 4.25V8.25M17 18.25V22.25M2 6.25H12M2 16.25H12M12 8.25H22M12 18.25H22M12 20.25V3.85C12 3.28995 12 3.00992 11.891 2.79601C11.7951 2.60785 11.6422 2.45487 11.454 2.35899C11.2401 2.25 10.9601 2.25 10.4 2.25H6.8C5.11984 2.25 4.27976 2.25 3.63803 2.57698C3.07354 2.8646 2.6146 3.32354 2.32698 3.88803C2 4.52976 2 5.36984 2 7.05V15.45C2 17.1302 2 17.9702 2.32698 18.612C2.6146 19.1765 3.07354 19.6354 3.63803 19.923C4.27976 20.25 5.11984 20.25 6.8 20.25H12ZM12 4.25H17.2C18.8802 4.25 19.7202 4.25 20.362 4.57698C20.9265 4.8646 21.3854 5.32354 21.673 5.88803C22 6.52976 22 7.36984 22 9.05V17.45C22 19.1302 22 19.9702 21.673 20.612C21.3854 21.1765 20.9265 21.6354 20.362 21.923C19.7202 22.25 18.8802 22.25 17.2 22.25H13.6C13.0399 22.25 12.7599 22.25 12.546 22.141C12.3578 22.0451 12.2049 21.8922 12.109 21.704C12 21.4901 12 21.2101 12 20.65V4.25Z",
    stroke: "#3E9BE4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.e79a7b7388b5cf7eae9ccca064f7ee26.svg";
export { ForwardRef as ReactComponent };